import intl from "react-intl-universal";

import type {AppState} from "@stores/AppState";
import {ActionName} from "./isAllowed";

import {Button} from "../ui/components/Button";
import {RocketLaunch} from "../ui/components/icons/RocketLaunchIcon";

import {screenSizeProvider} from "@stores/ScreenSizeProvider";
import {snackBarRef} from "@stores/snackbarRef";
import {MODALS} from "../ui/screens/modals/modal-names";


export const triggerLimitAlert = (appState: AppState, actionName: ActionName) => {
    const userState = appState.userState;
    const isAdmin = userState!.isCurrentUserAdmin

    const isMobile = screenSizeProvider.view !== 'desktop';
    const alertMessages = getAlertMessages(isAdmin, actionName);
    snackBarRef.current!.enqueueSnackbar({
        isCloseIcon: false,
        variant: "warning",
        message: alertMessages.message,
        Icon: RocketLaunch,
        action: () => (
            alertMessages.actionTest ? (
                <Button
                    text={alertMessages.actionTest}
                    type={'neutral'}
                    style={'soft'}
                    fullWidth={isMobile}
                    onClick={() => {
                        appState.setModal({name: MODALS.CHECKOUT, params: undefined});
                    }}
                />
            ) : null
        ),
        autoHideDuration: 10000,
    })
}

const getAlertMessages = (isAdmin: boolean, actionName: ActionName) => {
    switch (actionName) {
        case ActionName.CreateItem:
            return isAdmin
                ? {
                    actionTest: intl.get('header_menu.upgrade').d('Upgrade plan'),
                    message: intl.getHTML('alert.subscription_required.createItem').d(`<span>You’ve hit the limit of <b>50 pages and clusters.</b> Upgrade your plan to create more.</span>`),
                }
                : {
                    message: intl.get('alert.subscription_required.createItem.Editor').d("You've hit your free plan's limit of 50 pages and clusters. Contact your admin to upgrade plan."),
                };
        case ActionName.CreateQuiz:
            return {
                actionTest: intl.get('header_menu.upgrade').d('Upgrade plan'),
                message: intl.getHTML('alert.subscription_required.createQuiz').d(`You've hit the limit of <b>3 tests.</b> Upgrade your plan to create more tests.`),
            }
        case ActionName.InviteUsers:
            return {
                actionTest: intl.get('header_menu.upgrade').d('Upgrade plan'),
                message: intl.getHTML('alert.subscription_required.inviteUsers').d(`You’ve hit the limit of <b> 3 users on your Mini plan.</b> Upgrade to invite more team members.`),
            }
        case ActionName.CreateTaskListUnit:
            return isAdmin
                ? {
                    actionTest: intl.get('header_menu.upgrade').d('Upgrade plan'),
                    message: intl.getHTML('alert.subscription_required.createTaskListUnit').d(`<span>You've reached your location limit.</span> Upgrade your plan to add more locations.`),
                }
                : {
                    message: intl.get('alert.subscription_required.createTaskListUnit.Editor').d("You've reached your location limit. Contact your admin to upgrade the plan."),
                };
        default:
            throw new Error('not a valid action name');
    }
}
